export default {
  //Errors
  notFound: 'Inventory not found',

  // Words
  officialData: 'Official data',
  activeInventories: 'Active inventories',
  businessLicense: 'Business license',
  businessLicenseDate: 'Business license date',
  businessLicenseNo: 'Business license number',
  capacity: 'Capacity',
  cellNumber: 'Cell number',
  economicalCode: 'Economical code',
  enterInventory: 'Enter inventory',
  inventory: 'Inventory',
  inventoryActived: 'Inventory actived',
  inventoryName: 'Inventory name',
  inventoryRemoved: 'Inventory removed',
  inventorySuspended: 'Inventory suspended',
  inventoryUpdated: 'Inventory updated',
  kilogram: 'Kilogram',
  managerName: 'Manager name',
  managerNationalCode: 'Manager national code',
  nationalId: 'National ID',
  newInventoryAdded: 'New inventory added',
  operatorName: 'Operator name',
  phoneCode: 'Phone code',
  phoneNumber: 'Phone number',
  profileStatus: 'Profile status',
  suspendedInventories: 'Suspended inventories',
  valueAddedRegCert: 'Image of value added registration certificate from evat.ir site',
  workingHours: 'Working hours',
  fillingDataMessage: 'Receive accurate information about you and others, guaranteeing the health of your transactions and your peace of mind. Thank you for your patience in completing the information that is only needed once',
  confirmYourBasicData: 'Please fill your basic info',
  clickHereForFillBasicInfo: 'Click here to complete your basic information',
  bankAccounts: {
    accountNumber: 'Account number',
    accountOwnerName: 'Account owener name',
    accountTitle: 'Account title',
    bankAccounts: 'Bank accounts',
    bankAccountsUpdated: 'Bank accounts updated',
    bankName: 'Bank name',
    branchCode: 'Branch code',
    branchName: 'Branch name',
    enterBankName: 'Enter bank\'s name',
    shebaNumber: 'Sheba number'
  },
  basicData: {
    address: 'Address',
    barterPayment: 'Barter',
    barterPaymentDescription: 'Barter description',
    basicData: 'Basic data',
    basicDataUpdated: 'Basic data updated',
    birthdate: 'Birthdate',
    cashPayment: 'Cash',
    cashPaymentDescription: 'Cash description',
    checkPayment: 'Check',
    checkPaymentDescription: 'Check description',
    city: 'City',
    economicalCode: 'Economical code',
    fatherName: 'FatherName',
    identityData: 'Identity data',
    individual: 'Individual',
    legal: 'Legal',
    logo: 'Logo',
    name: 'name',
    nationalId: 'National id',
    officialData: 'Official data',
    officialFaxNumber: 'Fax number',
    officialPhoneCode: 'City phone code',
    officialPhoneNumber: 'Phone number',
    paymentPolicies: 'Payment policies',
    percent: 'percent',
    province: 'Province',
    regDate: 'Registration date',
    regNum: 'Registration number',
    seal: 'Seal image',
    zipCode: 'Zip code'
  },
  contacts: {
    address: 'Address',
    birthdate: 'Birthdate',
    contacts: 'Contacts',
    contactsUpdated: 'Contacts updated',
    gender: 'Gender',
    notes: 'Notes',
    position: 'Position',
    website: 'Website'
  },
  signatories: {
    insertUnderContract: 'Insert under contract',
    position: 'Position',
    signatorCertification: 'Signator certification',
    signatories: 'Signatories',
    signatoriesUpdated: 'Signatories updated',
    signatureImage: 'Signature image'
  },
  statusDescription: {
    approved: 'Your {profile} information is verified and you are allowed to act as a {profile}',
    disapproved: "Your {profile}'s information has been rejected by the management team, please register your request by pressing the button below. Your request will be reviewed and approved by the management team",
    filling: 'If you want to work as a {profile}, click on the button below and submit your application. Your request will be reviewed and approved by the management team.',
    pending: "Your {profile}'s information is subject to approval by the management team"
  },
  statuses: {
    approved: 'Approved',
    disapproved: 'Disapproved',
    filling: 'Filling',
    pending: 'Pending'
  },
}
